import(/* webpackMode: "eager", webpackExports: ["BlogPreview"] */ "/vercel/path0/frontend/src/components/home/BlogPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTABanner"] */ "/vercel/path0/frontend/src/components/home/CTABanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GovernmentScheme"] */ "/vercel/path0/frontend/src/components/home/GovernmentScheme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GuideMe"] */ "/vercel/path0/frontend/src/components/home/GuideMe.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/frontend/src/components/home/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerLogos"] */ "/vercel/path0/frontend/src/components/home/PartnerLogos.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServicesGrid"] */ "/vercel/path0/frontend/src/components/home/ServicesGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsSection"] */ "/vercel/path0/frontend/src/components/home/StatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/home/TestimonialsSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyChooseUs"] */ "/vercel/path0/frontend/src/components/home/WhyChooseUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTransition"] */ "/vercel/path0/frontend/src/components/layout/PageTransition.tsx");
